import { useRef } from 'react';
import OtherArticles from 'ui/components/molecules/OtherArticles';
import Link from 'next/link';
import SeeAllLink from './label';
import useIsNativeView from 'ui/hooks/useIsNativeView';
import { Article } from 'ui/interface';
import useImpressionNewsDetail from 'ui/hooks/emarsys/news/useImpressionNewsDetail';
import eventClickNewsDetail from '../../../helpers/emarsys/news/eventClickNewsDetail';
import { IBreadcrumbs } from 'ui/components/molecules/Breadcrumbs';

interface DetailArticleAnotherArticlesSectionProps {
  /* eslint-disable-next-line */
  handleCollectDataLayer?: any;
  /* eslint-disable-next-line */
  anotherArticles?: any;
  /* eslint-disable-next-line */
  enableSharing?: any;
  impressionData?: {
    breadCrumb?: IBreadcrumbs[];
    article?: Article;
  };
  feature?: string;
}
const DetailArticleAnotherArticlesSection = ({
  handleCollectDataLayer,
  anotherArticles,
  enableSharing = false,
  impressionData,
  feature,
}: DetailArticleAnotherArticlesSectionProps) => {
  const impressionRef = useRef(null);
  const isNativeView = useIsNativeView();

  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

  const handleBackToHomePage = (e) => {
    if (isNativeView) {
      e.preventDefault();
    }
    if (typeof window !== 'undefined') {
      /* eslint-disable-next-line */
      (window as any)?.androidApp?.goToNewsTipsList();
      /* eslint-disable-next-line */
      (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage('goToNewsTipsList');
    }

    if (feature === 'NEWS_DETAIL') {
      eventClickNewsDetail(
        impressionData?.article,
        impressionData?.breadCrumb,
        'lihat semua',
        'artikel lainnya'
      );
    }
  };

  if (feature === 'NEWS_DETAIL') {
    useImpressionNewsDetail(
      impressionRef,
      impressionData?.article,
      impressionData?.breadCrumb,
      'artikel lainnya'
    );
  }

  return anotherArticles?.length ? (
    <>
      <section className="my-4 lg:my-16" ref={impressionRef}>
        <div className="container lg:p-0">
          <div className="flex items-center justify-between mb-1 lg:mb-6">
            <p className="text-base font-bold uppercase text-reliableBlack lg:text-2xl">
              Artikel Lainnya
            </p>

            {enableSharing ? (
              <div>
                <SeeAllLink />
              </div>
            ) : (
              <Link
                id="link-semua-news"
                href={`${PUBLIC_URL}/berita-dan-tips`}
                className="bg-transparent text-reliableBlack text-xs font-semibold uppercase lg:text-base lg:font-medium"
                onClick={handleBackToHomePage}
              >
                <SeeAllLink />
              </Link>
            )}
          </div>

          {/* Another promo card */}
          <OtherArticles
            handleCollectDataLayer={handleCollectDataLayer}
            items={anotherArticles}
            enableSharing={enableSharing}
            optimize
          />
        </div>
      </section>
    </>
  ) : null;
};

export default DetailArticleAnotherArticlesSection;
